// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/********************************************************************************/
/* Header & Toolbar Styles */
/********************************************************************************/
body {
  width: 100vw;
  height: 100vh;
  min-width: 100vw;
  min-height: 100vh;
  margin: 0px;
}

.mindplot-div-container {
  width: 100%;
  height: 100%;
}

.wise-editor .popover {
  font-size: 13px;
  max-width: none;
}

@media print {
  body.print-zoom {
    transform: scale(.65);
    transform-origin: center left;
    /*width: 181.818%;*/
    width: 153.846%;
    height: auto;
    overflow: hidden;
  }

  @page {
    size: A4 landscape;
    margin: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./../editor/src/global-styled.css"],"names":[],"mappings":"AAAA,iFAAiF;AACjF,4BAA4B;AAC5B,iFAAiF;AACjF;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,qBAAqB;IACrB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;AACF","sourcesContent":["/********************************************************************************/\n/* Header & Toolbar Styles */\n/********************************************************************************/\nbody {\n  width: 100vw;\n  height: 100vh;\n  min-width: 100vw;\n  min-height: 100vh;\n  margin: 0px;\n}\n\n.mindplot-div-container {\n  width: 100%;\n  height: 100%;\n}\n\n.wise-editor .popover {\n  font-size: 13px;\n  max-width: none;\n}\n\n@media print {\n  body.print-zoom {\n    transform: scale(.65);\n    transform-origin: center left;\n    /*width: 181.818%;*/\n    width: 153.846%;\n    height: auto;\n    overflow: hidden;\n  }\n\n  @page {\n    size: A4 landscape;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
